import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Text/Filter.svg'
import _imports_1 from '@/assets/media/icons/duotone/Code/Code.svg'
import _imports_2 from '@/assets/media/icons/duotone/Communication/More.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4417b76e")

_pushScopeId("data-v-4417b76e")
const _hoisted_1 = { class: "fs-2" }
const _hoisted_2 = { class: "fs text-gray-600" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fs text-gray-600" }, " ", -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_8 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_9 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_11 = { class: "mb-1 fs-7" }
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_13 = { class: "mb-1 fs-7" }
const _hoisted_14 = { class: "svg-icon svg-icon-4" }
const _hoisted_15 = { class: "mb-1 fs-7" }
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = { class: "mb-1 fs-7" }
const _hoisted_18 = { class: "mb-1 fs-7" }
const _hoisted_19 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_20 = { class: "mb-1 fs-7" }
const _hoisted_21 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_22 = { class: "mb-1 fs-7" }
const _hoisted_23 = { class: "svg-icon svg-icon-4" }
const _hoisted_24 = { class: "svg-icon svg-icon-4" }
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_27 = {
  class: "modal modal-fullscreen fade",
  id: "kt_modal_2"
}
const _hoisted_28 = { class: "modal-dialog" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Response"),
  /*#__PURE__*/_createVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)
const _hoisted_33 = { class: "mb-5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Batch", -1)
const _hoisted_35 = { class: "mb-5" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Execute ", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", null, "Are you sure you want to execute this batch?", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_41 = { class: "dialog-footer" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_44 = { class: "mb-5" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Channel", -1)
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Format File", -1)
const _hoisted_48 = { class: "fs-7" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("File harus berupa .csv. Format file ")
const _hoisted_50 = /*#__PURE__*/_createVNode("fieldset", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Nama Kolom"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("transaction_date = "),
        /*#__PURE__*/_createVNode("strong", null, "Tanggal dimana transaksi asli dilakukan oleh nasabah"),
        /*#__PURE__*/_createTextVNode(", format: Y-m-d, contoh: 2022-12-20")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("channel_ref_id = "),
        /*#__PURE__*/_createVNode("strong", null, "Referensi ID Channel"),
        /*#__PURE__*/_createTextVNode(", contoh: 12345")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("type = "),
        /*#__PURE__*/_createVNode("strong", null, "Tipe transaksi journal entry,"),
        /*#__PURE__*/_createTextVNode("\n\n  value: IN atau OUT,  \n\n  IN = transaksi journal entry masuk, \n  OUT= transaksi journal entry keluar,\n\n  Contoh: IN\n                      ")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("fqva = "),
        /*#__PURE__*/_createVNode("strong", null, "Nomor VA"),
        /*#__PURE__*/_createTextVNode(", contoh: 8599010000000000")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("amount = "),
        /*#__PURE__*/_createVNode("strong", null, "Jumlah amount"),
        /*#__PURE__*/_createTextVNode(", contoh: 20000")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("journal_date = "),
        /*#__PURE__*/_createVNode("strong", null, "Tanggal terbit jurnal"),
        /*#__PURE__*/_createTextVNode(", format: Y-m-d, contoh: 2022-12-20")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("pre", { class: "fs-7" }, [
        /*#__PURE__*/_createTextVNode("transaction_source = "),
        /*#__PURE__*/_createVNode("strong", null, "Sumber transaksi"),
        /*#__PURE__*/_createTextVNode(", contoh: ATM Bersama")
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_col = _resolveComponent("el-col")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_FilterJournal = _resolveComponent("FilterJournal")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_pagination = _resolveComponent("pagination")
  const _component_table_skeleton = _resolveComponent("table-skeleton")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_upload = _resolveComponent("upload")
  const _component_base_button = _resolveComponent("base-button")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_el_card, null, {
      default: _withId(() => [
        _createVNode(_component_el_row, { class: "d-flex align-items-center mb-8" }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("reconcile.journal.title")), 1),
                _createVNode(_component_el_row, { class: "d-flex justify-content-between" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("reconcile.journal.subtitle")), 1),
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.currentTab,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentTab = $event))
        }, {
          default: _withId(() => [
            _createVNode(_component_el_tab_pane, {
              label: "List",
              name: "first"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_row, { class: "d-flex align-items-center mb-8" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_row, { class: "d-flex justify-content-between" }, {
                          default: _withId(() => [
                            _hoisted_4,
                            _createVNode("div", _hoisted_5, [
                              _createVNode("a", {
                                class: "btn btn-sm btn-flex btn-success fw-bolder me-2",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadExcel('Journal-Entry-list')))
                              }, [
                                _hoisted_6,
                                _hoisted_7
                              ]),
                              _createVNode("a", _hoisted_8, [
                                _createVNode("span", _hoisted_9, [
                                  _createVNode(_component_inline_svg, { src: _imports_0 })
                                ]),
                                _hoisted_10
                              ]),
                              _createVNode(_component_FilterJournal, { onFiltered: _ctx.filtered }, null, 8, ["onFiltered"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_table_skeleton, {
                  loading: !_ctx.data || _ctx.isValidating || _ctx.isDownloading
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      class: "Journal-table mt-8 fs-7",
                      data: _ctx.data?.data.data,
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "time",
                          label: "Channel"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              "header-align": "center",
                              prop: "time",
                              label: "Batch"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Channel",
                                  placement: "top-start"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_11, _toDisplayString(scope.row.channel.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_12,
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Batch",
                                  placement: "right"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_13, [
                                      _createTextVNode(_toDisplayString(scope.row.batch) + " ", 1),
                                      _createVNode("a", {
                                        class: "btn btn-sm btn-icon btn-white",
                                        onClick: ($event: any) => (_ctx.copyBatch(scope.row.batch))
                                      }, [
                                        _createVNode("span", _hoisted_14, [
                                          _createVNode(_component_inline_svg, { src: _imports_0 })
                                        ])
                                      ], 8, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "time",
                          label: "Import Time"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          label: "Transaction Date"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              "header-align": "center",
                              prop: "time",
                              label: "Journal Date",
                              width: "200"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Transaction Date",
                                  placement: "top-start"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_15, _toDisplayString(scope.row.transaction_date), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_16,
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Journal Date",
                                  placement: "right"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.moment(scope.row.journal_date).format('YYYY-MM-DD')), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "time",
                          label: "Channel Ref ID"
                        }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_tooltip, {
                              class: "box-item",
                              effect: "dark",
                              content: scope.row.type == 'IN' ? 'IN' : 'OUT',
                              placement: "top-start"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tag, {
                                  class: "ml-2",
                                  type: scope.row.type == 'IN' ? 'success' : 'danger'
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row.channel_ref_id), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 2
                            }, 1032, ["content"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "time",
                          label: "FQVA"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.fqva), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "time",
                          label: "Institution"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.institution.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "time",
                          label: "Transaction Source"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              "header-align": "center",
                              prop: "time",
                              label: "File Name"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Transaction Source",
                                  placement: "top-start"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_18, _toDisplayString(scope.row.transaction_source != null ? scope.row.transaction_source : '-'), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_19,
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "File Name",
                                  placement: "right"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_20, _toDisplayString(scope.row.file_reference_name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_21,
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Received At",
                                  placement: "left"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.moment(scope.row.received_date != null ? scope.row.received_date : scope.row.journal_date).format('YYYY-MM-DD HH:mm:ss')), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "right",
                          prop: "time",
                          label: "Amount",
                          width: "100"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.numberFormat(scope.row.amount.toString())), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "time",
                          label: "Response"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.response != null ? scope.row.response.substring(0, 15) : '') + " ", 1),
                            (scope.row.response != null)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  class: "btn btn-sm btn-icon btn-light mt-2 ms-2",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#kt_modal_2",
                                  onClick: () => { _ctx.jsonRespon = scope.row.response }
                                }, [
                                  _createVNode("span", _hoisted_23, [
                                    _createVNode(_component_inline_svg, { src: _imports_1 })
                                  ])
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "remark",
                          label: "Remark",
                          width: "80"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("a", {
                              class: "btn btn-sm btn-icon btn-white",
                              onClick: ($event: any) => (_ctx.showDialogRemark(scope.row.remark))
                            }, [
                              _createVNode("span", _hoisted_24, [
                                _createVNode(_component_inline_svg, { src: _imports_2 })
                              ])
                            ], 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "email",
                          label: "Email Sent",
                          width: "80"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (_ctx.data && _ctx.data.data.current_page)
                      ? (_openBlock(), _createBlock(_component_pagination, {
                          key: 0,
                          onChange: _ctx.handleChangePage,
                          ref: "paginationRef",
                          class: "mt-8",
                          "hide-when-only-one-page": true,
                          page: _ctx.data.data.current_page,
                          "per-page": _ctx.data.data.per_page ?? 0,
                          "total-current-page-item": _ctx.data.data.data.length,
                          "total-all-items": _ctx.data.data.total ?? 0
                        }, null, 8, ["onChange", "page", "per-page", "total-current-page-item", "total-all-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.dialogRemarkVisible,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogRemarkVisible = $event)),
                  title: "Remark",
                  width: "30%"
                }, {
                  footer: _withId(() => [
                    _createVNode("span", _hoisted_25, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogRemarkVisible = false))
                      }, {
                        default: _withId(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode("span", null, _toDisplayString(_ctx.remark), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode("div", _hoisted_31, [
                        _createVNode(_component_vue_json_pretty, {
                          data: _ctx.jsonRespon,
                          deep: 1
                        }, null, 8, ["data"])
                      ]),
                      _hoisted_32
                    ])
                  ])
                ]),
                _createVNode(_component_el_row, {
                  class: "d-flex",
                  gutter: 10
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { sm: 4 }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode("div", null, [
                            _createVNode(_component_el_input, {
                              size: "small",
                              modelValue: _ctx.batchCode,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchCode = $event)),
                              autocomplete: "off",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { sm: 4 }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createVNode("div", null, [
                            _createVNode("button", {
                              type: "reset",
                              class: "btn btn-sm btn-white btn-active-light-primary me-2",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetExecute && _ctx.resetExecute(...args)))
                            }, " Reset "),
                            _createVNode("button", {
                              type: "button",
                              ref: "submitButton",
                              class: "btn btn-primary",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)))
                            }, [
                              _hoisted_37,
                              _hoisted_38
                            ], 512),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogVisible,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = $event)),
                              title: "Confirmation",
                              width: "30%"
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_41, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_42
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.execute
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_43
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _hoisted_39,
                                _hoisted_40,
                                _createVNode("span", null, [
                                  _createVNode("strong", null, "Batch: " + _toDisplayString(_ctx.batchCode), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { sm: 4 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_descriptions, {
                          size: "small",
                          column: "1",
                          border: ""
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_descriptions_item, { label: "Total Amount" }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.numberFormat(_ctx.data?.total_amount)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Total Transaction" }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.data?.total_transaction), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.checkPermission('reconcile-journal-entry-action').isGranted)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: "Upload",
                  name: "second"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_row, { gutter: 50 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode("div", null, [
                                _createVNode(_component_el_select, {
                                  size: "small",
                                  modelValue: _ctx.hash,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.hash = $event)),
                                  placeholder: "Please select channel",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_option, {
                                      label: "",
                                      value: ""
                                    }),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channel, (value, key) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: key,
                                        label: value,
                                        value: key
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _createVNode(_component_upload, {
                              ref: "childComponentRef",
                              url: "#",
                              modelValue: _ctx.files,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.files = $event)),
                              multiple: false,
                              "auto-upload": false,
                              "button-label": "Select file",
                              class: "mb-4",
                              "file-types": ['.csv'],
                              accept: ".csv"
                            }, null, 8, ["modelValue", "file-types"]),
                            _createVNode(_component_base_button, {
                              loading: _ctx.isUploading,
                              disabled: _ctx.isUploading,
                              size: "small",
                              onClick: _ctx.handleSubmit,
                              type: "success"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.isUploading ? "Uploading" : "Upload"), 1)
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled", "onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 18 }, {
                          default: _withId(() => [
                            _createVNode("fieldset", _hoisted_46, [
                              _hoisted_47,
                              _createVNode("ul", null, [
                                _createVNode("li", null, [
                                  _createVNode("pre", _hoisted_48, [
                                    _hoisted_49,
                                    _createVNode("a", {
                                      href: "#",
                                      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)), ["prevent"]))
                                    }, "unduh disini")
                                  ])
                                ])
                              ])
                            ]),
                            _hoisted_50
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
})